export default {
  'dataQuality/issue/myWorkspace/page': {
    method: 'post',
    reply: 200,
    data: {
      status: '0',
      msg: 'success',
      data: {
        records: [
          {
            id: 0,
            idStr: '00001',
            issueTypeDesc: 'Automatically Created',
            dimensionDesc: 'Validity',
            dboDisplayName: 'Customer',
            dataStewardDisplayName: 'Wang Fei,BBA-4-D',
            dataAssetName: 'cus_sem_dmo2_t_company',
            tableName: 'dwc_dim_com_dmo2_t_company',
            columnName: 'dealer_id',
            ruleName: '经销商代码准确性',
            issueDescription: '经销商代码错误',
            statusDesc: 'Open',
            plantedClosureTime: '',
            itsmTicketNo: '0000004302',
            options: [''],
          },
        ],
        total: 22,
        size: 10,
        current: 1,
      },
    },
  },

  '/dataQuality/issue/myWorkspace/page/options': {
    method: 'get',
    reply: 200,
    data: {
      status: '0',
      msg: 'success',
      data: {
        dboList: ['Customer', 'People', 'OTD'],
        statusDescList: ['Draft', 'Open', 'Finished'],
      },
    },
  },
};
